// eslint-disable-next-line no-restricted-exports
export default function useVectorizationPermission() {
    const { payload } = storeToRefs(useTokenStore());
    const { isAuthorised } = useAuthorisationChecker();

    const canManageVectorization = computed(() =>
        isAuthorised({ permission: "manage vectorization" }),
    );

    // Während der Testphase legen die Agents des Kunden ausschließlich
    // Easytransfer-Logos (DTF) an — die Auswahl der Produktionsmethode entfällt,
    // damit nichts ablenkt. Owner und Admins bekommen alle Rechte pauschal über
    // den Token und dürfen weiterhin jede Methode verwenden.
    const isVectorizationOnlyUser = computed(
        () =>
            canManageVectorization.value &&
            !(payload.value?.is_owner ?? false) &&
            !(payload.value?.is_admin ?? false),
    );

    return { canManageVectorization, isVectorizationOnlyUser };
}
